import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import RegistrationDataPage from "../modules/RegistrationData/RegistrationDataPage";

export function RegistrationData() {
    const header = useHeader();
    header.setTitle(useIntl().formatMessage({
        id: "registrationData-page-title",
        defaultMessage: "Registration data"
    }));
    const subheader = useSubheader();
    subheader.setCustomClassName("subheader-custom-height");
    subheader.setDisplaySubheader(false);

    return <RegistrationDataPage/>;
}
